import { useFetchStudiesQuery, useFetchTrialSitesQuery } from '../api/SelectorApi';

import {
	saveStudyId,
	saveStudyName,
	saveTrialSiteId,
	selectStudyId,
	selectTrialSiteId,
} from '@/components/PatientDataTable';

export const FetchSelectorType = (type: string) => {
	switch (type) {
		case 'Study':
			return {
				fetch: useFetchStudiesQuery,
				title: 'Study',
				saveId: saveStudyId,
				saveName: saveStudyName,
				selectorId: selectStudyId,
				parentItemClickEnabled: true,
			};
		case 'Trial Site':
			return {
				fetch: useFetchTrialSitesQuery,
				title: 'Trial Site',
				saveId: saveTrialSiteId,
				selectorId: selectTrialSiteId,
				parentItemClickEnabled: false,
			};
		default:
			return {
				fetch: useFetchStudiesQuery,
				title: 'Study',
				saveId: saveStudyId,
				saveName: saveStudyName,
				selectorId: selectStudyId,
				parentItemClickEnabled: true,
			};
	}
};
